module.exports = __webpack_public_path__ + "static/media/italian-roast-dumpling.931ea0b9.png";